import { ReactNode, useState } from "react";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner, { stringifyLayout } from "../WebDesigner";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { GetWBComponentByTypename } from "../Data/WBData";
import { CSSClassNames } from "../CSSClassNameConstants";
import { OpenComponentColorPaletteMenu } from "./ComponentColorPaletteMenu";
import { OpenSaveAsSectionMenu } from "./SaveSectionMenu";
import { editTextPlaceHolder } from "../Data/WBComponentDefaults";
import { LoginUserType } from "utils/Utils";




export default function ComponentContextMenu({posX,posY,node,designer,closeMenu}:{posX:number,posY:number,node:LayoutNode,designer:WebDesigner,closeMenu:Function}){

    const menuStateParent = 1;
    const menuStateMove = 2;
    const menuStateStyling = 3;

    let x = posX-20;
    let y= posY -20;

    if(y+274>window.innerHeight){
        y = window.innerHeight-274;
    }
    if(x+210>window.innerWidth){

        x = window.innerWidth-210;
    }

    const [menuState,setMenuState] = useState(0);



    const parentOptions:LayoutNode[] = [];
    let parent = node.parent;

    while(parent && parent.typename!= wBComponentTypeNames.pageRoot){
        parentOptions.push(parent);
        if(parent.parent)
         parent = parent.parent;
        else
            break;
    }


    const MenuOption = ( {label,onSelect,hoverNode,isDisabled}: {label:ReactNode,onSelect:Function,hoverNode?:LayoutNode|null,isDisabled:boolean})=>{

        return <button className={"invisible-button "+CSSClassNames.overrideHover}
            onClick={(e)=>{onSelect(e);e.preventDefault();e.stopPropagation();}}
            onMouseEnter={() => {hoverNode&&designer.hoverById(hoverNode.id)}}
            disabled={isDisabled==true}
        >{label}</button>
    }


    const mainMenu = [
        {label:<div className="flex-row gap-med justify-between">{"Select Parent"} <RightCaret/></div>,onSelect:()=>{
            setMenuState(menuStateParent)
            if(parentOptions.length>0)
                designer.hoverById(parentOptions[0].id);//hover the first element since the mouse will already be insise so no mouseenter event is fired
        
        },isDisabled:parentOptions.length==0},
        {label:<div className="flex-row gap-med justify-between">{"Move"} <RightCaret/></div>,onSelect:()=>{setMenuState(menuStateMove)},
        isDisabled:designer.objectCanMoveInDirection(node,-1)==false&&designer.objectCanMoveInDirection(node,1)==false},
        {label:<div className="flex-row gap-med justify-between">{"Styling"} <RightCaret/></div>,onSelect:()=>{setMenuState(menuStateStyling)}},
        {label:"Duplicate",onSelect:()=>{designer.duplicateOjbectInPlace(node);closeMenu();}},

        {label:"Delete",onSelect:()=>{designer.deleteSelectedDoms();closeMenu();}},
        {label:"Cancel",onSelect:()=>{closeMenu()}}
    ]

    const stylingMenu = [
        {label:"Copy Styling",onSelect:()=>{designer.copyComponentAttributes(node);closeMenu();}},
        {label:"Paste Styling",onSelect:()=>{designer.pasteComponentAttributes(node);closeMenu();},isDisabled:!designer.copiedAttributeCollection},
        {label:"Pick From Palette",onSelect:()=>{OpenComponentColorPaletteMenu(designer.props.siteData,node);closeMenu();}},
        {label:"Reset to Default",onSelect:()=>{designer.clearComponentAttributes(node);closeMenu();}},
        {label:<div className="flex-row gap-small"><LeftCaret/>{"Cancel"} </div>,onSelect:()=>{setMenuState(0)}}

    ]

    const MoveMenu = [
        {label:"Move Back",onSelect:()=>{
            designer.moveComponentAdjacent(node,-1);
            closeMenu();
        },isDisabled:designer.objectCanMoveInDirection(node,-1)==false},
        {label:"Move Forward",onSelect:()=>{
            designer.moveComponentAdjacent(node,1);
            closeMenu();
        },isDisabled:designer.objectCanMoveInDirection(node,1)==false},
        {label:<div className="flex-row gap-small"><LeftCaret/>{"Cancel"} </div>,onSelect:()=>{setMenuState(0)}}
    ]

    const parentMenu = [];
    for(let i = 0;i<parentOptions.length;i++){
        const parent = parentOptions[i];
        const compName = GetWBComponentByTypename(parent.typename).displayName;
        parentMenu.push({label:compName,onSelect:()=>{designer.selectElementByLayoutObj(parent); closeMenu();},hoverNode:parent})

        if(compName === wBComponentTypeNames.section && designer.props.siteData.userContext.userType === LoginUserType.VagaroAdmin){
            let cancel = mainMenu.pop();

            let newNode = {...parent};
            newNode.content = ""; // clear content ref so it does show as "update" when adding section
            
            if(!parent.content||parent.content === editTextPlaceHolder)
                 mainMenu.push({label:"Save Section",onSelect:()=>{ 
    
                OpenSaveAsSectionMenu(stringifyLayout(newNode),designer.props.siteData);closeMenu();}})
            else if(parent.content&&parent.content.length>2){
                
             
                mainMenu.push({label:"Update Section",onSelect:()=>{ OpenSaveAsSectionMenu(stringifyLayout(newNode),designer.props.siteData,node.content as string,1);closeMenu();}})
    
            }
    
            if(cancel)
                mainMenu.push(cancel);
        }
        
    }
    parentMenu.push({label:<div className="flex-row gap-small"><LeftCaret/>{"Cancel"} </div>,onSelect:()=>{setMenuState(0)}})




    if(node.typename === wBComponentTypeNames.section && designer.props.siteData.userContext.userType === LoginUserType.VagaroAdmin){
        let cancel = mainMenu.pop();

        let newNode = {...node};
        newNode.content = ""; // clear content ref so it does show as "update" when adding section
        
        if(!node.content||node.content === editTextPlaceHolder)
             mainMenu.push({label:"Save Section",onSelect:()=>{ 

            OpenSaveAsSectionMenu(stringifyLayout(newNode),designer.props.siteData);closeMenu();}})
        else if(node.content&&node.content.length>2){
            
         
            mainMenu.push({label:"Update Section",onSelect:()=>{ OpenSaveAsSectionMenu(stringifyLayout(newNode),designer.props.siteData,node.content as string,1);closeMenu();}})

        }

        if(cancel)
            mainMenu.push(cancel);
    }

    let menu = [];
    switch(menuState){
        default:
            menu = mainMenu;
            break;
        case menuStateMove:
            menu = MoveMenu;
            break;
        case menuStateParent:
            menu = parentMenu;
            break;
        case menuStateStyling:
            menu = stylingMenu;
            break;

    }

    return (
        <>
        <div className="block-edit" id="opened-context-menu" style={{position:"fixed",zIndex:"3000",left:"0",top:"0",width:"100vw",height:"100vh",background:"none"}}
        
        onKeyDown={(e)=>{
         
            if(e.key=="Escape"){
                closeMenu();
                
            }
            else if(e.key=="Delete"){
                closeMenu();
              
            }
        }}
        onClick={()=>{closeMenu()}}>
            <div className="select-dropdown-options context-menu" style={{position:"absolute",left:x+"px",top:y+"px",maxWidth:"200px"}}>
                {
                    menu.map((item,index)=>{
                        
                        let hoverNode = menuState == menuStateParent&&index<parentOptions.length?parentOptions[index]:node;

                        return <MenuOption key={index} label={item.label} onSelect={item.onSelect} hoverNode={hoverNode} isDisabled={(item as any).isDisabled } />
                    })
                }


            </div>
        </div>
        </>


    )




}


export function RightCaret(props: any) {
    return (
    
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="1em" fill="currentColor"><path d="M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z" /></svg>
       
    )
}


export function LeftCaret(props: any) {


    return (
     
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" height="1em"><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" /></svg>
     
    )
}